import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

interface QueryClientWrapperProps {
  children: React.ReactNode;
}

export const queryClient = new QueryClient();

export function QueryClientWrapper({ children }: QueryClientWrapperProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={import.meta.env.NODE_ENV === "development"} />
    </QueryClientProvider>
  );
}
